/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Dispatch } from 'redux';
import type { BatchAction } from 'redux-batched-actions';
import { dismissFlagAction } from '../store/constants.tsx';
import type { Action } from '../store/types.tsx';
import { type DismissFlag, type FlagId, DISMISS_COMMAND } from '../types.tsx';

export const dismissFlag = (flagId: FlagId): DismissFlag => ({
	command: DISMISS_COMMAND,
	id: flagId,
});

const dismissFlagService =
	(dispatch: Dispatch<Action | BatchAction>) =>
	(action: DismissFlag): void => {
		dispatch(dismissFlagAction(action.id));
	};

export default dismissFlagService;
